import { render, staticRenderFns } from "./ruleConfiguration.vue?vue&type=template&id=5e891dc9&scoped=true"
import script from "./ruleConfiguration.vue?vue&type=script&lang=js"
export * from "./ruleConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ruleConfiguration.vue?vue&type=style&index=0&id=5e891dc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e891dc9",
  null
  
)

export default component.exports